import { render, staticRenderFns } from "./modal-minha-carteira.vue?vue&type=template&id=13eb8e10&"
import script from "./modal-minha-carteira.vue?vue&type=script&lang=js&"
export * from "./modal-minha-carteira.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VSpacer})


/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('13eb8e10')) {
      api.createRecord('13eb8e10', component.options)
    } else {
      api.reload('13eb8e10', component.options)
    }
    module.hot.accept("./modal-minha-carteira.vue?vue&type=template&id=13eb8e10&", function () {
      api.rerender('13eb8e10', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modal/modal-minha-carteira.vue"
export default component.exports